import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import HeadingsExample from '../examples/Headings';
import HeadingsHeroExample from '../examples/HeadingsHero';
const HeadingsExampleSource = require('!!raw-loader!../examples/Headings');
const HeadingsHeroExampleSource = require('!!raw-loader!../examples/HeadingsHero');
export default class HeadingsPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Heading"/>
                <h3>Heading</h3>
                <div className="docs-example">
                    <HeadingsExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{HeadingsExampleSource}</PrismCode>
                </pre>
                <h4>Heading Properties</h4>
                <pre>
                    <PrismCode className="language-jsx">
                        {`
Heading.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
    level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired,
    className: PropTypes.string,
};

Heading.defaultProps = {
    className: '',
};
`}
                    </PrismCode>
                </pre>
                <h4>Heading Hero</h4>
                <p>Hero small is responsible with smaller line height on tablet.</p>
                <div className="docs-example">
                    <HeadingsHeroExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{HeadingsHeroExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
